<template>
    <div>
        <el-card class="mb20">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/newsList' }">消息列表</el-breadcrumb-item>
                <el-breadcrumb-item>消息详情</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>

        <el-card>
            <div class="notice-detail">
                <div  class="list">

                    <el-row type="flex" class="list-item">
                        <el-col :span="1">
                            <img class="avater" :src='newsDetail.avatar ? newsDetail.avatar :"https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif"' alt="">
                        </el-col>
                        <el-col :span="20">
                            <strong class="mb15">{{newsDetail.nickName}}</strong>
                            <div class="mb15">
                                {{newsDetail.title}}
                            </div>
                            <div>
                            <span>内容:</span>
                            <article v-html="content" style="font-size:17px;line-height:2;"></article>
                            </div>
                            <div style="color: #9b9b9b">{{newsDetail.createTime}}</div>
                        </el-col>
                    </el-row>

                </div>

            </div>
        </el-card>
    </div>
</template>


<script>
    export default {
        name: "notice-detail",

        data () {
            return {

                newsDetail:{
                    content:''
                },
            }
        },
        computed:{
            content(){
                return this.newsDetail.content.replace(/\<p/gi,'<p style="font-size:17px;line-height:2;" ')
            }
        },
        methods: {
            getNoticeDetail (){

                //    调详情的接口
                    this.api.newsCenter
                            .getNotice({
                                id:this.$route.query.id
                            })
                            .then(res => {
                                if (res.success) {
                                    this.newsDetail = res.data;

                                } else {
                                    this.$message.error(res.message);
                                }
                            });

            },

        },
        created(){
            this.getNoticeDetail();
        },
    }
</script>
<style lang="less">

    .mb20 {
        margin-bottom: 20px;
    }
    .notice-detail {

    }
    .notice-detail {

        .mb15 {
            margin-bottom: 15px;
        }
        .list-item {
            padding: 30px;
            margin-bottom: 10px;
           img.avater {
                width: 30px;
                height: 30px;
                border-radius: 100%;
            }
            strong {
                display: inline-block;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/newsCenter/newsDetail.vue